import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Coord } from '@99designs/browser';
import { borders, boxShadows, colors, spaces, typography } from '@99designs/emu/settings';
import { FeedbackMode } from '../../../FeedbackModeProvider';

interface AnnotationTooltipProps {
    active?: boolean;
    mouseCoords?: Coord;
}
const AnnotationTooltip = styled.div<AnnotationTooltipProps>`
    position: fixed;
    pointer-events: none;
    opacity: 0;
    transition: 0.25s opacity;
    font-size: ${typography.typeScale.size1}px;
    line-height: ${typography.lineHeights.medium};
    color: ${colors.grey800};
    background: ${colors.white};
    padding: ${spaces['0.25bu']} ${spaces['0.75bu']};
    box-shadow: ${boxShadows.medium};
    border-radius: ${borders.borderRadiuses.small};
    z-index: 99; /* This helps position the tooltip above annotation dots */
    user-select: none;

    ${({ active = false }) =>
        active &&
        css`
            opacity: 1;
        `}

    ${({ mouseCoords = { x: 0, y: 0 } }) =>
        mouseCoords &&
        css`
            left: ${mouseCoords.x + 15}px;
            top: ${mouseCoords.y - 14}px;
        `}
`;

interface FeedbackTooltipProps {
    feedbackMode: FeedbackMode;
}

function FeedbackTooltip({ feedbackMode }: FeedbackTooltipProps) {
    const [mouseCoords, setMouseCoords] = useState<Coord>({ x: 0, y: 0 });
    const onMouseMove = ({ clientX, clientY }: MouseEvent) => {
        setMouseCoords({ x: clientX, y: clientY });
    };
    useEffect(() => {
        window.addEventListener('mousemove', onMouseMove);
        return () => {
            window.removeEventListener('mousemove', onMouseMove);
        };
    }, []);

    if (feedbackMode === 'none') {
        return null;
    }

    const message = {
        annotate: __('Click to comment'),
        sketch: __('Click and hold to draw'),
    };

    return (
        <AnnotationTooltip active mouseCoords={mouseCoords}>
            {message[feedbackMode]}
        </AnnotationTooltip>
    );
}

export default FeedbackTooltip;
